import { Location } from "history";
import { Reducer, useReducer } from "react";
import { useLocation } from "react-router";
import { DamagedConfirmation } from "./DamagedConfirmation";
import { LostOrStolenConfirmation } from "./LostOrStolenConfirmation";
import { lostStolenDamagedReducer } from "./reducer";
import { ReportLostStolenOrDamaged } from "./ReportLostStolenOrDamaged";
import { Action, LocationState, Pages, State } from "./types";
import { getInitialState } from "./utils";

export const LostStolenOrDamaged = () => {
  const { state: locationState } = useLocation() as Location<LocationState>;

  const [state, dispatch] = useReducer<Reducer<State, Action>>(
    lostStolenDamagedReducer,
    getInitialState(locationState.account, locationState.product),
  );

  switch (state.page) {
    case Pages.ERROR: {
      return <p>ERROR</p>;
    }
    case Pages.UNAVAILABLE: {
      return <p>UNAVAILABLE</p>;
    }
    case Pages.SUCCESS: {
      return <p>SUCCESS</p>;
    }
    case Pages.REPORT_LOST_STOLEN_OR_DAMAGED: {
      return (
        <ReportLostStolenOrDamaged
          cardEndsWith={state.cardEndsWith}
          scheme={state.scheme}
          personalDetailsUrl={state.personalDetailsUrl}
          dispatch={dispatch}
          token={state.token}
          lostStolenDamagedUrl={state.lostStolenDamagedUrl}
        />
      );
    }
    case Pages.REPORT_DAMAGED_CONFIRMATION: {
      return (
        <DamagedConfirmation
          cardEndsWith={state.cardEndsWith}
          address={state.address}
          lostStolenDamagedUrl={state.lostStolenDamagedUrl}
          token={locationState.account.credit_card?.token!}
          dispatch={dispatch}
        />
      );
    }
    case Pages.REPORT_LOST_STOLEN_CONFIRMATION: {
      return (
        <LostOrStolenConfirmation
          cardEndsWith={state.cardEndsWith}
          address={state.address}
          scheme={state.scheme}
          dispatch={dispatch}
          token={locationState.account.credit_card?.token!}
          lostStolenDamagedUrl={state.lostStolenDamagedUrl}
        />
      );
    }
    default: {
      return null;
    }
  }
};
